import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ApproverTick } from "../../assets/svg/check-mark.svg";
import { ReactComponent as CheckTrue } from "../../assets/svg/check-true.svg";
import { ReactComponent as CheckFalse } from "../../assets/svg/check-false.svg";
import { ReactComponent as ArrowRight } from "../../assets/svg/arrow-right.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import GuestImage from "../../assets/svg/guest-photo.svg";

 const CheckListFailedModal = ({checkList, loginPerson, onSave,onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",          
          padding: "16px 24px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "464px",
          height:"493px",
          overflowY: "auto",
        },
      };
      useEffect(() => {
        console.log(loginPerson)
    },[]) 
         
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div>
              <div className="checklist-modal-title"
    >
    Check list failed? 
    </div>
    <div className="checklist-modal-sub-title mt-2">
    Are you sure want to approve this visitor to gate in? 
    This action cannot be undone.
                    </div>
     
            </div>

            <div style={{marginTop:'8px' }}>
           
           <div className="approver-box style-justify-start">
           <img className="approver-image" src={loginPerson['profile_image'] === '' || loginPerson['profile_image'] == null?GuestImage:loginPerson['profile_image']} alt="guest"/> 
           <div style={{paddingLeft:'8px'}}>
            <div className="item-add-title">
            {loginPerson["first_name"]??''} 
            </div>
            <div className=" style-justify-start">
            <ApproverTick/> <span className="approver-txt">Approver</span>
            </div>
           </div>
           </div>
                            
           <div className="mt-3">
            <div className="checklist-title-txt">
            Check lists 
            </div>
            </div>    
              
           <div style={{height:'156px', overflowY:'scroll'}}>
           {checkList.map((check, index) =>{
          return <div className="checklist-card style-justify-between mt-1">
            <div className="style-justify-start">
              <ArrowRight/> <span className="check-list-name-modal"> {check.name}</span>
            </div>
            <div className="style-justify-start">
            <span className={`check-list-name-modal ${check.status===false?'check-list-value-failed':'check-list-value-success'}`}> {check.value==='true'?'Yes':check.value==='false'?'No':check.value}</span> {check.status===false?<CheckFalse/>:<CheckTrue/>}   
            </div>
          </div>
           })}
           </div>
              
             
              <Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="cancel-checklist-modal-btn style-justify-center"                  
                >
                 Cancel
                </div>
                <div className="save-checklist-modal-btn style-justify-center"
                  onClick={ (e) => {
                     onSave() 
                   
                  }}>
                  Proceed
                </div>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>);

}

export default CheckListFailedModal;